import { createTheme } from '@mantine/core';
import { mantineColors, palette } from './palette';

export const borisMantineTheme = createTheme({
  primaryColor: 'slate',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, sans-serif',

  colors: {
    ...mantineColors,
  },

  white: palette.surfaceCard,

  components: {
    Card: {
      defaultProps: {
        shadow: 'sm',
        padding: 'lg',
        radius: 'md',
        withBorder: true,
      },
      styles: {
        root: {
          borderColor: palette.border,
          backgroundColor: palette.surfaceCard,
        },
      },
    },
    Text: {
      defaultProps: {
        size: 'md',
      },
    },
    Button: {
      defaultProps: {
        radius: 'md',
      },
    },
  },

  radius: {
    xs: '4px',
    sm: '6px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },

  spacing: {
    xs: '8px',
    sm: '12px',
    md: '16px',
    lg: '24px',
    xl: '32px',
  },

  shadows: {
    xs: '0 1px 2px 0 rgb(0 0 0 / 0.05)',
    sm: '0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)',
    md: '0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)',
    lg: '0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1)',
  },
});
